export const REPORT_STATE_IS_LOADING = 'REPORT_STATE_IS_LOADING';
